import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DateState {
  selectedDate: any;
}

const initialState: DateState = {
  selectedDate: new Date(),
};

const dateSlice = createSlice({
  name: 'date',
  initialState,
  reducers: {
    setDate: (state, action: PayloadAction<any>) => {
      state.selectedDate = action.payload;
    },
  },
});

export const { setDate } = dateSlice.actions;
export default dateSlice.reducer;
